// @flow

/**
 * Returns a function that contains a scope to the ref of a new tab.
 * Allows the ability to async load a page after the tab has already
 * been opened
 */
export function prepareNewTab(initialLocation: string = 'about:blank') {
    const windowRef = window.open(initialLocation, '_blank');
    return function openNewTab(nextLocation: string) {
        windowRef.location.href = nextLocation;
    };
}
